import injectIntl from "../../../../../common/helpers/injectIntl";
import { connect } from "react-redux";
import { IStateTree } from "../../../../store/interfaces";
import { IUser, SolfaAudioType } from "../../../../store/user/models";

import lazyComponent from "./lazy";

const mapStateToProps = ({ user }: IStateTree) => ({
    reversedToneset: (user as IUser).reversedToneset || false,
    solfaAudio: (user as IUser).solfaAudio || SolfaAudioType.Solfa,
});

export default connect(mapStateToProps)(injectIntl(lazyComponent));
